module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhead3-06647ada6465dced84eec0549a9aad88.jpg";